// logger.js

const log = (page, ...args) => {
    console.log(`[${page}]`, ...args);
  };
  
  export default log;
  